export const MODAL_STEPS = [
  'description',
  'provider-selection',
  'provider-link-status',
  'consent-form',
  'success'] as const;

export type ModalStep = typeof MODAL_STEPS[number];
